<div class="demooz_select" 
    [class.no_margin]="this.noMargin"
    [class.disabled]="this.disabled"
    [class.text_left]="this.textAlign === 'left'"
    [class.text_right]="this.textAlign === 'right'"
    (click)="this.openListModal($event)"
    >
    <div class="demooz_select_label">
        @if(this.iconSelect !== ''){
            <ion-icon class="demooz_select_icon_prefix" [name]="this.iconSelect"></ion-icon>
        }
                
        @if(this.isRequired){
            <div class="demooz_input_required">*</div>
        }

        <ion-label class="demooz_select_placeholder">{{this.labelSelect}}</ion-label>
    </div>
    
    @for(itemSelected of this.getItemsSelected(); track $index){
        <demooz-tag size="small" [showCloseButton]="true" [color]="itemSelected.color" [noMargin]="true" (onCloseTag)="this.unselectItem(itemSelected)">{{itemSelected.label}}</demooz-tag>
    }
    
    <ion-select 
        [name]="this.formName" 
        [formControlName]="this.formName"        
        [multiple]="this.multiple"        
        [compareWith]="this.compareWith"
        >
        @for(item of this.items; track item.value){
            <ion-select-option [value]="item.value" >{{item.label}}</ion-select-option>  
        }
    </ion-select>
    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="demooz_input_error">{{this.errorText}}</div>
}

<ion-popover class="demooz_select_popover_options" #popoverSelect side="bottom" alignment="center" size="cover">
    <ng-template>        
        <ion-content>
            <demooz-list #demoozListPopover                
                [items]="this.items" 
                [maxItemsDisplayed]="this.maxItemsDisplayed" 
                [itemsSelected]="this.itemsSelectedCopy" 
                [multiple]="this.multiple" 
                [displayItemsColors]="this.displayItemsColors" 
                [displayItemsSelected]="this.displayItemsSelected" 
                [withSearch]="this.withSearch" 
                [searchDefault]="this.searchDefault" 
                (onSearchEnd)="this.onSearchEnd($event)" 
                (onSelectItem)="this.onSelectItem($event)"                
            ></demooz-list>
        </ion-content>
        @if(this.multiple || !this.autoClose){
            <ion-footer>
                <ion-toolbar>                
                    <ion-grid class="no_padding">
                        <ion-row class="ion-justify-content-around">   
                            <ion-col size="auto">
                                <demooz-button type="button" label="{{ 'MAIN.CANCEL' | translate }}" icon="close-outline" color="secondary" size="small" (click)="this.cancelChoices()" />
                            </ion-col>
                            <ion-col size="auto">
                                <demooz-button type="button" label="{{ 'MAIN.VALIDATE' | translate }} ({{this.getCountItemsSelected()}})" icon="checkmark-outline" color="primary" size="small" (click)="this.validateChoices()" />
                            </ion-col>                        
                        </ion-row>
                    </ion-grid>                
                </ion-toolbar>
            </ion-footer>
        }
    </ng-template>
</ion-popover>

<ion-modal #modalList 
    class="demooz_modal_list" 
    [class.hide]="this.hideListModal"
    [canDismiss]="this.canDismissListModal.bind(this)"
    (didDismiss)="this.onDidDismissListModal($event)" 
    >
    <ng-template>        
        <ion-content>
            <demooz-list #demoozListModal 
                [items]="this.items" 
                [maxItemsDisplayed]="this.maxItemsDisplayed" 
                [itemsSelected]="this.itemsSelectedCopy" 
                [multiple]="this.multiple" 
                [displayItemsColors]="this.displayItemsColors" 
                [displayItemsSelected]="this.displayItemsSelected" 
                [withSearch]="this.withSearch" 
                [searchDefault]="this.searchDefault" 
                (onSearchEnd)="this.onSearchEnd($event)" 
                (onSelectItem)="this.onSelectItem($event)"
            ></demooz-list>
        </ion-content>
        <ion-footer>
            <ion-toolbar>                
                <ion-grid class="no_padding">
                    <ion-row class="ion-justify-content-around">   
                        <ion-col size="auto">
                            <demooz-button type="button" label="{{ 'MAIN.CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancelChoices()" />
                        </ion-col>
                        <ion-col size="auto">
                            <demooz-button type="button" label="{{ 'MAIN.VALIDATE' | translate }} ({{this.getCountItemsSelected()}})" icon="checkmark-outline" color="primary" (click)="this.validateChoices()" />
                        </ion-col>                        
                    </ion-row>
                </ion-grid>                
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>
